import React from 'react';
import CoachesCRM from '../../crm/CoachesCRM';

// SessionNotes component wrapper that uses CoachesCRM's SessionNotes
// This ensures consistency across the application
const SessionNotes = () => {
  // Since CoachesCRM has SessionNotes as a local component,
  // we'll render CoachesCRM with the sessions tab active
  // For a standalone view, we can create a separate component if needed
  return (
    <div className="p-4 sm:p-6">
      <CoachesCRM />
    </div>
  );
};

export default SessionNotes;
